import {
  ARCHIVED_CHAT_LIST_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
  OWNED_SHARED_CHATS_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

import { chatShareQueryKey } from "./chat-share.constants";

// NOTE: Removes one or many recipients in a single request. Per-row removal
// passes a single-element array; bulk removal passes the selected set — both
// take one rate-limit hit instead of one DELETE per recipient.
export const useRemoveChatShareRecipients = (chatUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (recipientUuids: string[]) =>
      chatApi.removeChatShareRecipients(chatUuid, { recipientUuids }),
    onSuccess: (data) => {
      // NOTE: NSAI-3499 — the Shared chats overview shows the recipient count,
      // or drops the share once the last recipient is gone.
      queryClient.invalidateQueries({
        queryKey: [OWNED_SHARED_CHATS_QUERY_KEY],
      });
      // NOTE: Removing everyone auto-revokes the link server-side; cache null so
      // the header pill / sidebar indicator clear, and refresh the chat lists.
      if (data.recipients.length === 0) {
        queryClient.setQueryData(chatShareQueryKey(chatUuid), null);
        queryClient.invalidateQueries({ queryKey: [CHAT_LIST_QUERY_KEY] });
        queryClient.invalidateQueries({
          queryKey: [ARCHIVED_CHAT_LIST_QUERY_KEY],
        });
        return;
      }
      queryClient.setQueryData(chatShareQueryKey(chatUuid), data);
    },
    // NOTE: ShareChatDialog owns its error toast, so suppress the global one.
    meta: { suppressErrorToast: true },
  });
};
